module.exports = __webpack_public_path__ + "media/bra/bghead-7eae445f.png";